export default {
  sha: "077b8c9c90292c220ec07e638a4c6ee2243c856a",
  version: " (APP-4818-cloudfront)",
}
